import React from 'react';
import Footer from './common/Footer';

const ShippingPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-900 relative overflow-hidden">
    

      <div className="flex-grow flex flex-col items-center py-12 px-4 sm:px-6 lg:px-8">
        {/* Logo Section */}
        <div className="w-full max-w-lg mb-8">
          <div className="flex flex-col items-center relative z-10">
            <img
              src="/images/imr-logo.png"
              alt="IMR Logo"
              className="h-32 w-auto mb-4"
            />
            <h1 className="text-center text-2xl font-bold text-yellow-500">
              DEFENCE INDUSTRY DIRECTORY
            </h1>
          </div>
        </div>

        {/* Shipping Policy Content */}
        <div className="w-full max-w-4xl relative z-10">
          <div className="bg-gray-800/90 shadow-lg rounded-lg p-8 border border-gray-700 backdrop-blur-sm text-gray-300">
            <h2 className="text-2xl font-bold text-yellow-500 mb-6">Shipping and Delivery Policy</h2>
            <p className="text-sm mb-4">Effective Date: 1 June 2025</p>
            
            <p className="mb-6">
              This Shipping and Delivery Policy explains how services are delivered to both Annual Subscribers 
              and Directory Participants on directory.defencepartners.in.
            </p>

            <div className="space-y-6">
              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">1. Nature of Delivery</h3>
                <ul className="list-disc pl-6 space-y-1">
                  <li>No physical goods are shipped. All services are delivered electronically via the website and email.</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">2. Annual Subscribers</h3>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Upon successful payment, Annual Subscribers will receive their login credentials via the email address provided during registration.</li>
                  <li>Access to the directory and its features will be activated immediately or within 24 hours of payment confirmation.</li>
                  <li>If you do not receive your login details within 24 hours, please contact us at directory@defencepartners.in for assistance.</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">3. Directory Participants (Companies)</h3>
                <ul className="list-disc pl-6 space-y-1">
                  <li>After payment and submission of required company information, your listing will be reviewed for completeness and compliance.</li>
                  <li>Listings are published in the directory within 2 business days of successful verification and payment.</li>
                  <li>You will receive a confirmation email once your listing is live.</li>
                  <li>If there are issues with your submission, we will contact you for clarification or additional information.</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">4. Delivery Issues</h3>
                <ul className="list-disc pl-6 space-y-1">
                  <li>For any issues regarding access, login credentials, or listing publication, please contact us promptly at directory@defencepartners.in.</li>
                  <li>We are not responsible for delays caused by incorrect or incomplete information provided by the user.</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">5. Tracking and Confirmation</h3>
                <ul className="list-disc pl-6 space-y-1">
                  <li>All deliveries (login credentials or listing publication) will be confirmed via email.</li>
                  <li>No physical shipping or tracking numbers are applicable.</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">6. Service Availability</h3>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Our services are available online and accessible globally, subject to applicable laws and regulations.</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">7. Contact</h3>
                <p>For any questions or concerns regarding this policy or the delivery of your service, please contact us at directory@defencepartners.in.</p>
              </section>

              <p className="mt-8 text-sm text-gray-400">
                By using directory.defencepartners.in, you acknowledge and agree to this Shipping and Delivery Policy.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ShippingPolicy;
